import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-congres-virtuel',
  templateUrl: './congres-virtuel.component.html',
  styleUrls: ['./congres-virtuel.component.scss']
})
export class CongresVirtuelComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
